import * as React from 'react';
import {EMessageType, IMessage} from '../../Constants/Interfaces';
import {useSelector} from 'react-redux';
import {parseUsers} from '../../Users';
import {parseNotifications, readMessage} from '../../Messages';
import {isMyId} from '../../Utils';
import {getLastFourChars} from '../Users/utils';
import {IMessageProps, Message} from './Message';
import {MyMessage} from './MyMessage';


export const MessageData: React.FC<{ key: string; message: IMessage }> = ({message}) => {

    const Users = useSelector(parseUsers);
    const Notifications = useSelector(parseNotifications);

    const isMyMessage: boolean = isMyId(message.sender);

    const sender = Users.all.find((user) => user.uid === message.sender);

    const senderIdLastDigits = getLastFourChars(message.sender);

    const unread = !!Notifications[message.sender];

    const onRead = () => readMessage(message);
    const setMessageRead =
        unread && onRead ? onRead : undefined;

    const blocked = Users.my.blacklist.includes(message.sender);

    const properties = {
        key: message.timestamp,
        name: message.sender_name + '#' + senderIdLastDigits,
        message: message.message,
        online: sender?.online || false,
        avatar: sender?.avatar?.face,
        align: isMyMessage ? 'right' : 'left',
        unread: message.unread,
        setMessageRead: setMessageRead,
        blocked,
        edited: !!message.edited,
        type: message.type,
        isMyMessage,
        timestamp: message.timestamp,
    } as IMessageProps;


    return message.type === EMessageType.system || !isMyMessage
        ? <Message {...properties}/>
        : <MyMessage id={message.timestamp} {...properties}/>;
};